export default {

    value: 'القيمة',
    name_ar: 'الاسم العربي',
    name_en: 'الاسم الانجليزي',
};
